import { render, staticRenderFns } from "./dev_to_user_messages.vue?vue&type=template&id=5752f07a&scoped=true&"
import script from "./dev_to_user_messages.vue?vue&type=script&setup=true&lang=ts&"
export * from "./dev_to_user_messages.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./dev_to_user_messages.vue?vue&type=style&index=0&id=5752f07a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752f07a",
  null
  
)

export default component.exports